import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import TablePagination from '@material-ui/core/TablePagination'
import { medicationsTypesActions, confirmActions, messageActions } from '../../actions'
import jwt_decode from 'jwt-decode'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import { reloadTable } from '../../utils/reloadTable'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchMedicationsTypes, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchMedicationsTypes({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchMedicationsTypes, changeOrderColumn, order, term } = this.props
    fetchMedicationsTypes()
  }

  renderActions = item => {
    const {
      fetchMedicationType,
      deleteMedicationType,
      addConfirm,
      token,
      restoreMedicationType
    } = this.props

    return (
      <Fragment>
        {readOnly('tiposmedicamentos', token) &&
          !item.deletedAt && (
            <IconButton
              onClick={() => {
                fetchMedicationType(item._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!item.deletedAt && findPermission('tiposmedicamentos', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste tipo de medicamento?',
                confirmFunction: () => {
                  restoreMedicationType(item._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('tiposmedicamentos', token).editar && (
              <IconButton
                onClick={() => {
                  fetchMedicationType(item._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('tiposmedicamentos', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste tipo de medicamento?',
                    confirmFunction: () => {
                      deleteMedicationType(item._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchMedicationsTypes, order, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchMedicationsTypes, handleChangePerPage, order, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const {
      order,
      changeOrderColumn,
      changeOrderDirection,
      fetchMedicationsTypes,
      pagination,
      term
    } = this.props

    const { page, rowsPerPage: perPage } = pagination

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  render() {
    const {
      classes,
      medicationsTypes = [],
      loadingMedicationsTypes,
      addConfirm,
      restoreMedicationType,
      pagination,
      order = {}
    } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingMedicationsTypes && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Tipo de medicamento
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(medicationsTypes || []).length ? (
              (medicationsTypes || []).map(content => {
                return (
                  <TableRow key={content._id}>
                    <TableRowColumn>{content.nome}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(content)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingMedicationsTypes ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    medicationType: state.medicationsTypes.medicationType,
    medicationsTypes: state.medicationsTypes.medicationsTypes,
    loadingMedicationsTypes: state.medicationsTypes.loadingMedicationsTypes,
    token: state.auth.token,
    pagination: state.medicationsTypes.medicationsTypesPagination,
    order: state.medicationsTypes.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(medicationsTypesActions.openModal())
    },
    closeModal: () => {
      dispatch(medicationsTypesActions.closeModal())
    },
    fetchMedicationType: id => {
      dispatch(medicationsTypesActions.fetchMedicationType(id))
    },
    fetchMedicationsTypes: options => {
      dispatch(medicationsTypesActions.fetchMedicationsTypes(options))
    },
    deleteMedicationType: id => {
      dispatch(medicationsTypesActions.deleteMedicationType(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restoreMedicationType: id => {
      dispatch(medicationsTypesActions.restoreMedicationType(id))
    },
    handleChangePage: page => {
      dispatch(medicationsTypesActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(medicationsTypesActions.handleChangePerPage(perPage))
    },
    changeOrderColumn: column => {
      dispatch(medicationsTypesActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(medicationsTypesActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/MedicationsTypes/ListTable.js